<template>
    <div class="flex flex-col items-center justify-center text-center">
        <h1 class="text-center  text-3xl lg:text-5xl font-bold lg:w-2/5 mx-auto">Simple understanding of your short term Liquidity</h1>
        <div class="flex flex-col lg:flex-row justify-around items-center lg:items-start w-4/5 mt-4 lg:mt-10">
            <div class="w-full lg:w-1/3 m-5">
                We show you the essentials: <br>
                Payments you get and what you have to pay. See if your balance is sufficient.
            </div>
            <div class="w-full lg:w-1/3 m-5">
                Coming: Use recurrent Payments to spare you the trouble of repeating payments.
            </div>
            <div class="w-full lg:w-1/3 m-5">
                Coming: Get Mail or SMS Notification of upcoming payments. Never forget to pay.
            </div>
        </div>

        <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 mt-3 lg:mt-12 rounded-full">
            <router-link to="login">
                Get started
            </router-link>
        </button>

        <h2 class="text-3xl lg:text-4xl font-bold mt-8 lg:mt-20">Simple</h2>
        <p class="w-full lg:w-1/3">You simple enter what expenses you have and your income / revenue you already know or anticipate.</p>

        <h2 class="text-3xl lg:text-4xl font-bold mt-4 lg:mt-16">Understanding</h2>
        <p class="w-full lg:w-1/3">As you type you will see the effect on your liquidity and balance. Start your action immediately!</p>

        <h2 class="text-3xl lg:text-4xl font-bold mt-4 lg:mt-16">Short Term Liquidity</h2>
        <p class="w-full lg:w-1/3">See what you can afford and what you have to plan to save or survive the future.</p>

        <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 my-8 lg:my-20 rounded-full">
            <router-link to="login">
                Click here and start for free!
            </router-link>
        </button>
        <!-- <h1>Welcome to Liquidity Flow</h1> -->
        <!-- <p>
            The tool that allows you to plan and overview your financial possibilities in the near future.
        </p> -->
    </div>
</template>

<script>
// @ is an alias to /src

export default {
    name: 'Home',
    components: {
    },
};
</script>

<style scoped>
</style>
